export enum IconType {
  'checkbox' = 'checkbox',
  'radio' = 'radio',
}

export interface Data {
  valueCheckbox: boolean
}
